/**
 *
 * Tenant View constants
 *
 */


export const TENANT_ANNOUNCEMENT_DX_GRID = 'TenantAnnouncementDxGrid';
export const TENANT_ANNOUNCEMENT_FORM = 'TenantAnnouncementForm';
export const TENANT_ANNOUNCEMENT_FORM_DIALOG = 'TenantAnnouncementFormDialog';

export const EXECUTE_VIEW_ACTION = 'claris-vnext/AnnouncementPage/TenantView/EXECUTE_VIEW_ACTION';
export const HANDLE_PARAMS_ACTION = 'claris-vnext/AnnouncementPage/TenantView/HANDLE_PARAMS_ACTION';

